import { ZoneMasterThemeSizeConfig } from './types';

const medium: ZoneMasterThemeSizeConfig = {
  zoneMaster: {},
};

export default medium;
